import { render, staticRenderFns } from "./qcteam_text.vue?vue&type=template&id=23cf0d4c&scoped=true"
import script from "./qcteam_text.vue?vue&type=script&lang=js"
export * from "./qcteam_text.vue?vue&type=script&lang=js"
import style0 from "./qcteam_text.vue?vue&type=style&index=0&id=23cf0d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf0d4c",
  null
  
)

export default component.exports